export default __webpack_public_path__ + "static/media/modifierGroup-img.959f7b42.svg";